import * as React from "react";
import { DateField, TextField, EditButton, TextInput, FunctionField } from "react-admin";
import { Datagrid, IfCanAccess, List } from "src/enterprise/ra-rbac";

const listFilters = [<TextInput source="search" label="Search" alwaysOn />];
export const NewsletterList = (props) => (
  <List {...props} filters={listFilters} queryOptions={{ cacheTime: 0 }}>
    <Datagrid>
      <TextField source="id" />
      <FunctionField label="User" render={record => record.user ? record.user.first_name+" "+record.user.last_name : "" }/>
      <TextField source="email" />
      <DateField source="created_at" label="Created At" />
      <IfCanAccess action="edit">
        <EditButton />
      </IfCanAccess>
    </Datagrid>
  </List>
);
